import {SportstypeSpec} from "../types";
import start from "../../icons/badminton_team/start";
import end from "../../icons/badminton_team/end";
import score from "../../icons/badminton_team/score";
import main from "../../icons/badminton_team/main";

const badminton_team: SportstypeSpec = {
  id: 'badminton_team',
  scoreboardType: 'set-based-scoreboard',
  svg: main,
  releaseStage: 'alpha',
  phases: ['pregame', {id: 'set', max: 3}, 'postgame'],
  events: [
    {
      id: 'start',
      important: true,
      svg: start
    },
    {
      id: 'end',
      important: true,
      svg: end
    },
    {
      id: 'score',
      important: true,
      svg: score
    }
  ]
}

export default badminton_team
